export default "__VITE_ASSET__BviXj2UL__"